import { restClient } from '@/Core'

/**
 * Групове переміщення в папку: `POST /services/disk/nodes/move`. Зайняту назву
 * бек розводить «Назва (1)» (`keep_both` за замовчуванням), як провідник ОС.
 */
export const MoveDiskNodesTask = async (nodes: string[], target: string): Promise<void> => {
    await restClient.post('/services/disk/nodes/move', { json: { nodes, target } })
}
